import { ISalesHistoryItem } from 'parts/types';

export const getBillToAccountValue = (
  item?: Pick<ISalesHistoryItem, 'billToAccount' | 'billToAccountName'>
) => [item?.billToAccountName, item?.billToAccount].filter(Boolean).join(' ');

export const getSalesLocationValue = (
  item?: Pick<ISalesHistoryItem, 'salesLocation' | 'salesLocationName'>
) => [item?.salesLocationName, item?.salesLocation].filter(Boolean).join(' ');
